import { Link } from 'react-router-dom';
import { getHotComics, type Comic } from '@/mocks/comics';

function ComicCard({ comic, rank }: { comic: Comic; rank?: number }) {
  return (
    <Link to={`/comic/${comic.id}`} className="group block" data-product-shop>
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200 mb-3">
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title} - 免费在线看漫画全集`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {rank && (
          <div className="absolute top-2 left-2 w-7 h-7 flex items-center justify-center bg-primary-500 text-white text-xs font-bold rounded-full">
            {rank}
          </div>
        )}
        <div className="absolute top-2 right-2 px-2 py-0.5 bg-black/60 text-white text-xs rounded-md">
          {comic.status}
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent pt-8 pb-3 px-3">
          <div className="flex items-center gap-1 text-accent-400">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-star-fill text-xs"></i>
            </div>
            <span className="text-xs font-medium">{comic.rating}</span>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
        {comic.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
    </Link>
  );
}

export default function HotPicks() {
  const hotComics = getHotComics(6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">大家都在看的漫画，不容错过</p>
          </div>
          <Link
            to="/category/rexue"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看更多
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {hotComics.map((comic, index) => (
            <ComicCard key={comic.id} comic={comic} rank={index + 1} />
          ))}
        </div>
      </div>
    </section>
  );
}